import { render, staticRenderFns } from "./GoComposition.vue?vue&type=template&id=171eabba&scoped=true&"
import script from "./GoComposition.vue?vue&type=script&lang=js&"
export * from "./GoComposition.vue?vue&type=script&lang=js&"
import style0 from "./GoComposition.vue?vue&type=style&index=0&id=171eabba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171eabba",
  null
  
)

export default component.exports